import { URL_RESOLVER } from "../assets/graphql";
import { apiHandler } from "../api";
import { endpoint } from "../api/endpoint";
import { getHomepageData } from "../api/HomePage";
import { toast } from "react-toastify";

export const getSampleCurrencyFormat = (currency, value) => {
  switch (currency) {
    case "NGN":
      return new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency,
      }).format(value);
    case "KES":
      return new Intl.NumberFormat("sw-KE", {
        style: "currency",
        currency,
      }).format(value);
    case "USD":
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency,
      }).format(value);
    case "EUR":
      return new Intl.NumberFormat("en-EU", {
        style: "currency",
        currency,
      }).format(value);
    case "GBP":
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "GBP",
      }).format(value);
    case "XAF":
      return new Intl.NumberFormat("fr-CM", {
        style: "currency",
        currency: "XAF",
      }).format(value);
    case "INR":
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency,
      }).format(value);
    default:
      return new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: currency || "INR",
      }).format(value);
  }
};

export const getUrlResolver = async (url_key) => {
  // debugger
  // console.log(url_key,"url_key_value")
  const result = await apiHandler({
    url: endpoint.GRAPHQL_URL,
    method: "POST",
    data: {
      base_url: endpoint.API_BASE_URL,
      variables: { url: url_key + ".html" },
      query: URL_RESOLVER,
    },
  });
  // console.log(result.data,"utlis Result")
  return result.data;
};

export const checkSessionValidity = (result, dispatch) => {
  console.log("session", localStorage.getItem("sessionTimeOut"))
  if (localStorage.getItem("sessionTimeOut") === 'true') {
    if (
      result &&
      result.errors &&
      result.errors[0] &&
      result.errors[0].extensions &&
      result.errors[0].extensions.category === "graphql-authorization"
    ) {
      localStorage.setItem('loginCheck', false);
      localStorage.setItem("sessionTimeOut", false);
      localStorage.clear();
      toast.error("Session Expired");
      window.location.reload();
      dispatch({ type: "SIGNOUT" });
    } else if (
      result &&
      result.message &&
      result.message.errors &&
      result.message.errors[0] &&
      result.message.errors[0].extensions &&
      result.message.errors[0].extensions.category === "graphql-authorization"
    ) {
      localStorage.setItem('loginCheck', false);
      localStorage.setItem("sessionTimeOut", false);
      localStorage.clear();
      console.log("in API Auth Error");
      toast.error("Session Expired");
      window.location.reload();
      dispatch({ type: "SIGNOUT" });
    } else if (
      result &&
      result.message &&
      typeof result.message == "string" &&
      result.message.includes('{"category":"graphql-authorization"}')
    ) {
      localStorage.setItem('loginCheck', false);
      localStorage.setItem("sessionTimeOut", false);
      localStorage.clear();
      window.location.reload();
      dispatch({ type: "SIGNOUT" });
      toast.error("Session Expired");
      getHomepageData({ dispatch });
    }
  }
};

